export const DELIVERY_ZONE_CENTER = { lat: 41.6423, lon: 41.6339 };

export const DELIVERY_ZONE_RADIUS_METERS = 15_000;

function haversineDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number {
  const earthRadiusMeters = 6_371_000;
  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) ** 2;

  return earthRadiusMeters * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function isLocationInDeliveryZone(lat: number, lon: number): boolean {
  return (
    haversineDistance(
      DELIVERY_ZONE_CENTER.lat,
      DELIVERY_ZONE_CENTER.lon,
      lat,
      lon,
    ) <= DELIVERY_ZONE_RADIUS_METERS
  );
}
